import { Route, Routes } from 'react-router-dom';
import UsersTable from './UsersTable'
import { CreateEditUsersMobile } from './CreateEditUserMobile';

const UsersPage = () => {
  return (
    <Routes>
      <Route index element={<UsersTable />} />
      <Route path="create" element={<CreateEditUsersMobile />} />
      <Route path=':id/edit' element={<CreateEditUsersMobile />} />
    </Routes>
  )
}

export default UsersPage;